<div class="products-active-filters" *ngIf="(searchResult && searchResult.activeFilters) || checkSearchQuery" #container>
  <h5 *ngIf="sidePanel" class="selected-filters-title">
    {{ "filters.selectedFilters" | translate }}
  </h5>

  <ng-container *ngFor="let filter of searchResult.activeFilters; trackBy: trackByIndex">
    <div class="active-filter color-body-text font-style-book" *ngIf="filter.name">
      <span class="filter-name" [innerHtml]="filter?.name + ':'"></span>
      <div class="filter-content">
        <ng-container *ngFor="let value of filter?.values; let i = index">
          <span class="tag" (click)="change({ filter: filter, index: i })">
            <span [innerHTML]="value.value"></span>
          </span>
          <ng-container *ngIf="i < filter?.values.length - 1">
            <ng-container *ngIf="filter.multiselectConjunction == '-~-' || filter.type =='Interval' ">
              <span class="conjunction">
                {{ "filters.conjunctionAnd" | translate }}
              </span>
            </ng-container>
            <ng-container *ngIf="filter.multiselectConjunction == '~~~'">
              <span class="conjunction">
                {{ "filters.conjunctionOr" | translate }}
              </span>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="placeholder" *ngIf="filter?.name == ''"></div>
  </ng-container>

  <div class="active-filter query color-body-text font-style-book"    *ngIf="checkSearchQuery"  >
    <div class="filter-name">
      {{ "activeFilters.search" | translate }}:
    </div>
    <span class="tag" (click)="clearQuery()">
      {{ searchResult?.searchQuery.query}}
    </span>
  </div>

  <div class="active-filter query color-body-text font-style-book"    *ngIf="searchResult?.searchQuery?.similarToItemName"  >
    <div class="filter-name">
      {{ "activeFilters.similarToItem" | translate }}:
    </div>
    <span class="tag" (click)="clearSti()">
      {{ searchResult?.searchQuery.similarToItemName}}
    </span>
  </div>

    <div class="active-filter query color-body-text font-style-book" *ngIf="searchResult?.searchQuery?.recommendationType"  >
    <div class="filter-name">
      {{ "activeFilters.recommendation" | translate }}:
    </div>
    <span class="tag" (click)="clearSti()">
      {{ ("activeFilters."+ searchResult?.searchQuery.recommendationScenario) | translate }}
    </span>
  </div>

  <div class="unselect-all" *ngIf="searchResult?.activeFilters.length && searchResult?.activeFilters[0].name != '' && !sidePanel" (click)="unselectAll()">
    <a class="success-link tiny-text">
      {{ "activeFilters.removeAllFilters" | translate }}
    </a>
  </div>
</div>
